import bingoModal from './index.vue';
export default  bingoModal;



// WEBPACK FOOTER //
// ./src/components/bingo-modal/index.js